// extracted by mini-css-extract-plugin
export var lg = "_44-4";
export var md = "_44-3";
export var sm = "_44-2";
export var xs = "_44-1";
export var xxs = "_44-0";